import Flickity from "flickity";

require("flickity/dist/flickity.css");

function ProductCarousels(selector) {
    let carousels = selector;

    if (typeof selector === "string") {
        carousels = document.querySelectorAll(selector);
    }

    if (!carousels) return;

    Array.from(carousels, (carousel) => {
        new Carousel(carousel);
    });
}

function Carousel(carousel) {
    const contents_flickity = new Flickity(".carousel--products", {
        selectedAttraction: 0.1,
        friction: 1,
        cellAlign: "left",
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true,
        imagesLoaded: true,
        autoPlay: false,
        // arrowShape:
        // "M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z",
    });
}

export default ProductCarousels;



// WEBPACK FOOTER //
// ./js/components/products/index.js